namespace Gordic.Vyp.Dlg
{
    const { gcontent } = Decorators

    @gcontent
    export class PredplneniZasilkyDlg extends GContentBase
    {
        model: Wfl.Interface.GPredplneniZasilekDto;
        validators: any;

        onContentReady()
        {
            const form = new Gordic.Forms.Form({ name: "FormZasEdit", layoutDescriptor: "L1M1S1" });
            form.addPrefab(VypPrefabs.SekcePredplneniZasilek());
            this.defaultForm = $("<div>").appendTo(this.element).gform("createFrom", form);
            this.findFields().gfield("model", "apply", this.model).gfield("model", "validators", this.validators);
        }

        OKClick()
        {
            if (this.defaultForm)
            {
                if (!this.defaultForm.gform("isValid")) return;
                this.findFields().gfield("model", "collect", this.model);
                this.close(this.model);   
            }       
        }
    }
}